import { useRouteError, useNavigate } from "react-router-dom";
import { ProjectButton } from "./project/style";

function ErrorPage() {
  const error = useRouteError();
  console.error(error);
  const navigate = useNavigate();

  const message =
    (typeof error?.data === "string" && error.data) ||
    (typeof error?.data?.message === "string" && error.data.message) ||
    (typeof error?.message === "string" && error.message) ||
    (typeof error?.statusText === "string" && error.statusText) ||
    (() => {
      try {
        return error?.data ? JSON.stringify(error.data) : "Something went wrong.";
      } catch {
        return "Something went wrong.";
      }
    })();

  return (
    <div id="error-page">
      <div
        className="d-flex flex-column align-items-center pt-5"
        style={{ gap: "20px" }}
      >
        <h4 className="text-center">{message}</h4>
        <ProjectButton
          size="20px !important"
          padding="8px 20px"
          onClick={() => navigate("/")}
        >
          Take me to Home
        </ProjectButton>
      </div>
    </div>
  );
}

export default ErrorPage;
